export const rangeWiseReportSubMenu = [{
  path: '/report/range-wise-report/list',
  component: () => import('@/views/report/range-wise-report/list.vue'),
  name: 'report.title',
  meta: {
    title: 'report.rangeWiseReport.title',
    roles: ['Super Admin', 'Read Only', 'Branch Manager', 'Zonal Manager'],
    noCache: true,
    hidden: false,
    icon: 'tree-table'
  }
}];